/**
 * @file multipleWarehouse.ts
 * @module api/apiJSON/multipleWarehouse
 * @description Defines multipleWarehouse API request configuration and payload helpers.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 1.2.5
 */

export const multipleWarehouseJSON = {
    addWarehouse: ( warehouseData:any) => {
      console.log('warehouseDataaasas', warehouseData)
      let tempData: any = {};
      if (warehouseData) {
        tempData.name = warehouseData.name
        tempData.email = warehouseData.email
        tempData.phone = warehouseData.phone
        tempData.phoneCountry = warehouseData.phoneCountry
        tempData.address = warehouseData.address
        tempData.lat = warehouseData.lat
        tempData.lng = warehouseData.lng
        tempData.district = warehouseData.district.map((val:any)=> val.value)
        tempData.manager = warehouseData.manager.map((val:any)=> val.value)
        tempData.discount = 0;
        tempData.discountType = warehouseData?.discount1?.length ? 1 : 2;
        tempData.roundValue = 0;
      }
      return tempData;
    },
  };
